<template>
  <div v-if="type == 'template'">
    <k-autocomplete
    :label="label"
    :item-text="(item) => { return get_title(item) }"
    item-value="id"
    v-model="val"
    :items="filtered_items"
    append-outer-icon="fa-plus"
    @click:append-outer="add_template"
    @change="add_template">
    </k-autocomplete>

    <span v-for="(item, i) in channel_groups">
      <k-chip size="s" color="primary" close @click:close="remove_template(i)" v-if="item_visible(item)">
        {{get_title(item)}}
      </k-chip>
    </span>
  </div>

  <div v-else>
   <k-autocomplete
    :label="label"
    :item-text="(item) => { return get_title(item) }"
    item-value="id"
    v-model="val"
    :items="filtered_items"
    append-outer-icon="fa-plus"
    @click:append-outer="add_template"
    @change="add_template">
    </k-autocomplete>

    <span v-for="(item, i) in channel_groups">
      <k-chip color="primary" size="s" close @click:close="remove_template(i)" v-if="item_visible(item)">
        {{get_title(item)}}
      </k-chip>
    </span>


  </div>

</template>

<script>
export default {
  props: ["id", "type", "value", "label"],
  data () {
    var ch = this.$cloudserver.channel("channels:channel_groups:"+this.id);
    return {
      ws_channel: ch,
      channel_groups: this.convertChannelGroups(ch.data),
      val: undefined,
      expiry_time: -1
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.channel_groups = this.convertChannelGroups(newVal, oldVal);
        }
      },
      deep: true
    },
    channel_groups(newVal) {
      this.$emit("input", newVal);
    }
  },
  created () {
    this.ws_channel.join();
  },
  computed: {
    items() {
      var list;
      if(this.type == "template") {
        return _.values(this.$store.state.channel_templates);
      } else {
        return _.values(this.$store.state.channel_access_groups);
      }
    },
    filtered_items() {
      return _.filter(this.items, (item) => {
        return _.isEmpty(_.find(this.channel_groups, (i) => { return i.id == item.id; })) && item.state == "active";
      })
    }
  },
  methods: {
    get_item(id) {
      return _.find(this.items, (i) => { return i.id == id })
    },
    item_visible(item) {
      return !_.isEmpty(this.get_item(item.id));
    },
    get_title(item) {
      var item = this.get_item(item.id);
      if(item.type == "template") {
        return _.get(item, "title", "") + " (W: " + _.get(item, "meta.weight", 0) + ")";
      }
      return _.get(item, "title", "");
    },
    add_template(item) {
      var self = this;
      if (typeof(this.val) != "undefined" && this.val != null && _.isEmpty(_.find(this.channel_groups, (i) => { return i == this.val; }))) {
        this.channel_groups.push({id: this.val, expiry_time: this.expiry_time});
      }
      this.$nextTick(function() {
        self.val = undefined;
      });
    },
    remove_template(idx) {
      this.channel_groups.splice(idx, 1);
    },
    convertChannelGroups(newVal, oldVal) {
      var channel_groups = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }

      if(typeof(channel_groups) == "undefined" || _.isEmpty(channel_groups)) return [];
      return channel_groups;
    }
  }
}
</script>